import { Badge } from "@/components/ui/badge";

export default function JornadaHoySubnivel({ jornada }) {
  if (!jornada) return null;

  return (
    <div className="mt-1.5" data-testid="jornada-hoy-subnivel">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-indigo-600">Tu jornada hoy</p>
      {jornada.ausencia ? (
        <p className="mt-0.5 text-sm font-medium text-amber-700">{jornada.ausencia.label}</p>
      ) : jornada.festivo ? (
        <p className="mt-0.5 text-sm font-medium text-sky-700" data-testid="jornada-festivo">
          {jornada.festivo.nombre}
          <span className="ml-1 font-normal text-sky-600/80">· día inhábil retribuido</span>
        </p>
      ) : jornada.activo && jornada.franjas?.length ? (
        <div className="mt-1 space-y-1">
          <div className="flex flex-wrap items-center gap-1.5">
            {jornada.franjas.map((f, i) => (
              <Badge key={i} variant="outline" className="border-indigo-200 bg-indigo-50 text-indigo-800 text-xs">
                {f.inicio} – {f.fin}
              </Badge>
            ))}
            {jornada.turno_nombre && (
              <span className="text-xs text-zinc-500">· {jornada.turno_nombre}</span>
            )}
          </div>
          {jornada.ajustado_por_entrada && (
            <p className="text-[11px] text-teal-800" data-testid="jornada-ajustada-entrada">
              Horario ajustado según tu entrada
              {jornada.franjas_originales?.length
                ? ` (previsto ${jornada.franjas_originales.map((f) => `${f.inicio}–${f.fin}`).join(" · ")})`
                : ""}
              . Salida indicada:{" "}
              <strong>{jornada.franjas[jornada.franjas.length - 1]?.fin}</strong>
            </p>
          )}
        </div>
      ) : (
        <p className="mt-0.5 text-sm text-zinc-500">Hoy no tienes jornada prevista</p>
      )}
    </div>
  );
}
